import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import CapitalWorld from "@/components/home/CapitalWorld";
import Problem from "@/components/home/Problem";
import PipelineSection from "@/components/home/PipelineSection";
import Programmable from "@/components/home/Programmable";
import CashFlow from "@/components/home/CashFlow";
import Categories from "@/components/home/Categories";
import ArcSection from "@/components/home/ArcSection";
import RwaThesis from "@/components/home/RwaThesis";
import FinalMessage from "@/components/home/FinalMessage";

export default function Home() {
    return (
        <div data-testid="home-page">
            <Hero />
            <Marquee />
            <CapitalWorld />
            <Problem />
            <PipelineSection />
            <Programmable />
            <CashFlow />
            <Categories />
            <ArcSection />
            <RwaThesis />
            <FinalMessage />
        </div>
    );
}
